import React from 'react'

export const IconClose = (props= {}) => {
	const { size= 20, imgSize= 20, fill="white" } = props
	return (
		<svg xmlns="http://www.w3.org/2000/svg"
				 width={`${size}px`}
				 height={`${size}px`}
				 viewBox={`0 0 ${imgSize} ${imgSize}`}
				 fill="none"
		>
			<path
				d="M17.1083 3.77494L16.2249 2.8916L9.99994 9.11579L3.77494 2.8916L2.8916 3.77494L9.11577 9.99996L2.8916 16.225L3.77494 17.1083L9.99994 10.8841L16.2249 17.1083L17.1083 16.225L10.8841 9.99996L17.1083 3.77494Z"
				fill={fill}
			/>
		</svg>
	)
}